import classNames from 'classnames'

import { FormattedPrice } from '@src/blocks/currency'
import { TEST_LOCATORS } from '@src/constants/test-locators'
import { Checkbox } from '@src/quince-components/src/atoms/checkbox/Checkbox'

import styles from './BundleProductCard.module.scss'

import type { BundleProductCardPriceAndTitleV2Props } from './bundle-product-card-price-and-title-v2.types'

const BundleProductCardPriceAndTitleV2Legacy = ({
  chooseProductText,
  discountedSalePrice,
  salePrice,
  isAddOnProduct = false,
  expanded,
  setExpanded,
}: BundleProductCardPriceAndTitleV2Props) => {
  return (
    <div className={styles.titleAndPriceSection_newDesignV2}>
      <div style={{ marginRight: '1rem' }}>
        <div className={styles.titleAndPriceSection_newDesignV2__title}>{chooseProductText}</div>
        <div className={styles.titleAndPriceSection_newDesignV2__pricing}>
          <div
            data-testid={TEST_LOCATORS.BUNDLE_PRODUCT_SALE_PRICE}
            className={styles.titleAndPriceSection_newDesignV2__pricing__salePrice}
          >
            <FormattedPrice amount={discountedSalePrice} />
          </div>
          <div className={styles.titleAndPriceSection_newDesignV2__pricing__salePriceBeforeBundleDiscount}>
            <FormattedPrice amount={salePrice} />
          </div>
        </div>
      </div>
      <div className={styles.checkboxAndTitle}>
        {isAddOnProduct ? (
          <div className={classNames(styles.checkboxWrapper, styles.checkboxWrapper_newDesignV2)}>
            {/* eslint-disable-next-line */}
            <Checkbox
              isChecked={expanded}
              setIsChecked={checked => {
                if (setExpanded) {
                  setExpanded(checked)
                }
              }}
              label={''}
              className={classNames(styles.checkboxWrapper, styles.checkboxWrapper_newDesignV2)}
              labelClassName={styles.checkBoxLabel}
            />
          </div>
        ) : null}
      </div>
    </div>
  )
}

export default BundleProductCardPriceAndTitleV2Legacy
